import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: "hoursToTimespan",
})
export class HoursToTimespanPipe implements PipeTransform {
    // convert tracked time from '00:00:00' to '00 hrs 0 min' format
    transform(hours: number | string): string {
        if (typeof hours === "string") {
          const match = hours.match(/^(\d{1,2}):(\d{2}) h$/);
          if (match && match.length === 3) {
            const hour = parseInt(match[1], 10);
            const min = parseInt(match[2], 10);
            if (!isNaN(hour) && !isNaN(min)) {
              return this.formatTime(hour, min);
            }
          }
        } else if (typeof hours === "number") {
          const hour = Math.floor(hours);
          const min = Math.floor((hours - hour) * 60);
          if (!isNaN(hour) && !isNaN(min)) {
            return this.formatTime(hour, min);
          }
        }
        return "";
      }
    
      private formatTime(hour: number, min: number): string {
        let timeString = "";
    
        if (hour > 0) {
          timeString += `${hour < 10 ? "0" + hour : hour} hrs `;
        }
    
        if (min >= 0) {
          timeString += `${min < 10 ? "0" + min : min} min`;
        }
    
        return timeString.trim();
      }
}
